// ------------------------------------------------------------------------------
// name: dark
// author: mudas
// created: 2024/12/9
// ------------------------------------------------------------------------------

import { ThemeConfig } from '@fuxi/eevee-ui';

export const DarkTheme: NonNullable<ThemeConfig['token']> = {
  colorBgContainer: '#0f0f18',
  colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
  colorBgElevated: '#161621',
  colorBgLayout: '#07070c',
  colorBgMask: 'rgba(0, 0, 0, 0.6)',
  colorBgTextHover: 'rgba(255, 255, 255, 0.12)',

  colorBorder: '#1e1e2f',
  colorBorderSecondary: '#1d1d31',
  colorSplit: 'rgba(255, 255, 255, 0.08)',

  colorError: '#e56585',
  colorErrorActive: '#9c495d',
  colorErrorBg: '#28191e',
  colorErrorBgHover: '#3f222a',
  colorErrorBorder: '#532c36',
  colorErrorBorderHover: '#723847',
  colorErrorHover: '#dc8597',
  colorErrorText: '#c65974',
  colorErrorTextActive: '#9c4955',
  colorErrorTextHover: '#dc8597',

  colorFill: 'rgba(206, 203, 255, 0.18)',
  colorFillQuaternary: 'rgba(178, 184, 255, 0.05)',
  colorFillSecondary: 'rgba(206, 203, 255, 0.1)',
  colorFillTertiary: 'rgba(206, 203, 255, 0.08)',

  colorIcon: 'rgba(255, 255, 255, 0.45)',
  colorIconHover: '#ffffff',

  colorInfo: '#707aff',
  colorInfoActive: '#443eaa',
  colorInfoBg: '#17182b',
  colorInfoBgHover: '#1f1e44',
  colorInfoBorder: '#2a2859',
  colorInfoBorderHover: '#35317c',
  colorInfoHover: '#7e75e8',
  colorInfoText: '#534bd8',
  colorInfoTextActive: '#443eaa',
  colorInfoTextHover: '#7e75e8',

  colorLink: '#5e55fa',
  colorLinkActive: '#443eaa',
  colorLinkHover: '#7e75e8',

  colorPrimary: '#6c63f9',
  colorPrimaryActive: '#443eaa',
  colorPrimaryBg: '#17182b',
  colorPrimaryBgHover: '#1f1e44',
  colorPrimaryBorder: '#2a2859',
  colorPrimaryBorderHover: '#35317c',
  colorPrimaryHover: '#7e75e8',
  colorPrimaryText: '#5e55fa',
  colorPrimaryTextActive: '#443eaa',
  colorPrimaryTextHover: '#7e75e8',

  colorSuccess: '#63e0ae',
  colorSuccessActive: '#479978',
  colorSuccessBg: '#192722',
  colorSuccessBgHover: '#213e33',
  colorSuccessBorder: '#2c5142',
  colorSuccessBorderHover: '#387059',
  colorSuccessHover: '#387059',
  colorSuccessText: '#57c197',
  colorSuccessTextActive: '#479978',
  colorSuccessTextHover: '#82d7b2',

  colorText: '#ffffff',
  colorTextLightSolid: '#ffffff',
  colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
  colorTextSecondary: 'rgba(255, 255, 255, 0.75)',
  colorTextTertiary: 'rgba(255, 255, 255, 0.45)',

  colorWarning: '#ff713e',
  colorWarningActive: '#ad502f',
  colorWarningBg: '#2c1915',
  colorWarningBgHover: '#452419',
  colorWarningBorder: '#5b3021',
  colorWarningBorderHover: '#7e3e27',
  colorWarningHover: '#7e3e27',
  colorWarningText: '#dc6338',
  colorWarningTextActive: '#ad502f',
  colorWarningTextHover: '#e8875e',

  colorWhite: '#ffffff',

  controlItemBgHover: 'rgba(178, 184, 255, 0.08)',
  colorBgSpotlight: '#1f1f2f', //'#232340',
  colorBgTextActive: 'rgba(206, 203, 255, 0.18)',
  colorBgBase: '#000000',
  colorBorderBg: '#0f0f18',

  colorTextHeading: '#ffffff',
  colorTextLabel: 'rgba(255, 255, 255, 0.75)',
  colorTextDescription: 'rgba(255, 255, 255, 0.45)',
  colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
  colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',

  boxShadow: '0 1px 2px 0px rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0px rgba(0, 0, 0, 0.02)',
  boxShadowSecondary:
    '0 6px 16px 0px rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.02), 0 2px 4px 0px rgba(0, 0, 0, 0.02)',

  padding: 16,
  paddingXXS: 4,
  paddingXS: 8,
  paddingSM: 12,
  paddingMD: 20,
  paddingLG: 24,
  paddingXL: 32,
  margin: 16,
  marginXXS: 4,
  marginXS: 8,
  marginSM: 12,
  marginLG: 24,
  marginXL: 32,
  marginXXL: 48,
  //height
  controlHeight: 32,
  controlHeightXS: 16,
  controlHeightSM: 24,
  controlHeightLG: 48,

  borderRadiusXS: 2,
  borderRadiusSM: 6,
  borderRadius: 8,
  borderRadiusLG: 10,
  borderRadiusOuter: 6,
};
